import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateFn,
} from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { UserService } from '@services/user.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionsGuardFn {
  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean> | boolean {
    let req_role: any[];
    let defaultRoute = route.data.defaultRoute || 'home';
    if (route.data && route.data.permission) {
      req_role = route.data.permission;
    } else {
      return of(true);
    }
    //If types are specified in the route data config,
    //check to see if the current rout uses that type before to see if a permission check is needed
    if (route.data.rest_type) {
      //temp container of permissions
      let restTypes = [];
      //req_role is an array of permission flags from the role
      req_role.forEach(role => {
        //rest_type is an object containing arrays. The key for each array is the permission, the array contains data types pertaining to that role
        const typeList = route?.data?.rest_type?.[role];
        if (
          !route.params.type ||
          !typeList ||
          !typeList.includes(route?.params?.type)
        ) {
        } else {
          //if the current data type is in the required type list for this permission, it needs to be checked add it to the temp permission list
          restTypes.push(role);
        }
      });
      //if there are items in temp permisison list, update to required permissions so only the needed permissions are checked
      //if no permissions need to be check completye the route
      if (restTypes.length === 0) {
        return of(true);
      } else {
        req_role = restTypes;
      }
    }
    let sub: Subject<boolean | UrlTree> = new Subject();
    this.userService
      .getRoleDetails(true)
      .pipe(take(1))
      .subscribe(roledetails => {
        const hasRoles = req_role.every(role => {
          const isLimitPermission = role.startsWith('limit_');
          const permissionValue = roledetails[role];
          const hasPermission = isLimitPermission
            ? !permissionValue
            : permissionValue;
          return hasPermission;
        });
        //
        if (hasRoles) {
          sub.next(true);
          sub.complete();
        } else {
          sub.next(this.router.parseUrl('/' + defaultRoute));
          sub.complete();
        }
      });

    return sub;
  }
}

export const RolePermissionsGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean> | boolean => {
  return inject(RolePermissionsGuardFn).canActivate(next, state);
};
